import axiosInstanceUser from '@user-plugins/axios/index.js'
import { useAuthStore } from '@user-plugins/store/modules/auth'
import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes.js'

const router = createRouter({
    history: createWebHistory(''),
    routes,
})

router.beforeEach(async (to) => {
    const authStore = useAuthStore()

    // Allow SSO callback to process without authentication check
    if (to.name === 'sso-callback') {
        return true
    }

    // If not authenticated in store, check session
    if (!authStore.authenticated && to.meta.middleware !== 'guest') {
        try {
            const { data } = await axiosInstanceUser.get('/session-auth')
            if (data.authenticated) {
                authStore.authenticated = true
                authStore.access_token = data.access_token
                authStore.user = data.user
                return true
            }
        } catch {
            // No valid session
        }
    }

    if (to.meta.middleware === 'guest') {
        if (authStore.authenticated) {
            return { name: 'dashboard' }
        }
        return true
    } else {
        if (authStore.authenticated) {
            return true
        }
        return { name: 'login' }
    }
})

export default router
